import { Badge } from '@mantine/core';

import { formatDeliveryStatus } from '../lib/status';
import type { Status } from '../lib/status';

const STATUS_COLORS: Record<string, string> = {
    Active: 'green',
    Paused: 'yellow',
    'Not delivering': 'orange',
    'Not approved': 'orange',
    'Pending billing info': 'orange',
    Removed: 'red',
    Deleted: 'red',
    Disapproved: 'red',
    'In progress': 'blue',
    'Pending review': 'blue',
    'Pre-approved': 'blue',
    'Ad set paused': 'yellow',
    'Campaign paused': 'yellow',
    Archived: 'gray',
    'With issues': 'orange',
};

export const StatusBadge = ({ status }: { status: Status }) => {
    const label = formatDeliveryStatus(status);
    const color = STATUS_COLORS[label] ?? 'gray';

    return (
        <Badge variant="light" color={color}>
            {label}
        </Badge>
    );
};
